export enum CustomListDetailsTabEnum {
  ListItems = "LIST_ITEMS",
  ListDetails = "LIST_DETAILS",
  ListNotes = "LIST_NOTES",
  ListStats = "LIST_STATS",
}
